var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6312 12.3466C9.68491 12.9703 8.55152 13.3334 7.33334 13.3334C4.01963 13.3334 1.33334 10.6471 1.33334 7.33337C1.33334 4.01967 4.01963 1.33337 7.33334 1.33337C10.647 1.33337 13.3333 4.01967 13.3333 7.33337C13.3333 8.70648 12.8721 9.97185 12.0961 10.983L14.9881 13.875L13.5739 15.2892L10.6312 12.3466ZM7.33342 11.3334C9.54256 11.3334 11.3334 9.54253 11.3334 7.33339C11.3334 5.12426 9.54256 3.33339 7.33342 3.33339C5.12428 3.33339 3.33342 5.12426 3.33342 7.33339C3.33342 9.54253 5.12428 11.3334 7.33342 11.3334Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputSearch);
export default __webpack_public_path__ + "static/media/input-search.064566f2688292ac0c06e91ac5274750.svg";
export { ForwardRef as ReactComponent };